package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.list_device.ListDeviceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.ListDeviceRepository

class ListDeviceUseCase(
    private val repository: ListDeviceRepository
) {
    suspend operator fun invoke(
        model: String
    ): ListDeviceModel {
        return repository.getListDevices(
            model = model
        )
    }
    
    fun cancel() {
        repository.cancel()
    }
} 